module.exports = __webpack_public_path__ + "d33f12753fa6e490b6d1596baa63606c.svg";